import { apiGet } from "../client";
import { useQuery } from "@tanstack/react-query";
import type { IPassage } from "./types";

/**
 * 특정 shared passage를 조회하는 API 함수
 */
export const apiGetPassage = async (id: string) => {
  const response = await apiGet<IPassage>(`/passages/${id}`);
  return response.data;
};

/**
 * 특정 shared passage를 React Query로 조회하는 훅
 */
export const useQueryGetPassage = (id: string, options = {}) => {
  return useQuery({
    queryKey: ["passage", id],
    queryFn: async () => {
      return await apiGetPassage(id);
    },
    enabled: !!id,
    ...options,
  });
};

export default useQueryGetPassage;
